import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import type { User } from '../models';
import { userApi } from '../services/api';

interface UserAutocompleteProps {
  value: any;
  onChange: (value: any) => void;
  label?: string;
  placeholder?: string;
  multiple?: boolean;
}

const UserAutocomplete: React.FC<UserAutocompleteProps> = ({ value, onChange, label = 'Select Users', placeholder = 'Search by name, username, or email', multiple = true }) => {
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState<User[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!inputValue) {
      setOptions([]);
      return;
    }
    setLoading(true);
    const handler = setTimeout(async () => {
      try {
        const params = new URLSearchParams();
        params.append('search', inputValue);
        params.append('page_size', '10');
        const res = await userApi.getUsers(params.toString());
        setOptions(res.results || []);
      } catch {
        setOptions([]);
      }
      setLoading(false);
    }, 400);
    return () => clearTimeout(handler);
  }, [inputValue]);

  return (
    <Autocomplete
      multiple={multiple}
      options={options}
      value={value}
      onChange={(_e, newValue) => {
        console.log('[UserAutocomplete] selected:', newValue);
        onChange(newValue);
      }}
      getOptionLabel={(option) => `${option.first_name} ${option.last_name} (${option.username})`}
      isOptionEqualToValue={(option, val) => String(option.id) === String(val.id)}
      filterSelectedOptions
      filterOptions={(x) => x}
      loading={loading}
      inputValue={inputValue}
      onInputChange={(_e, newInputValue) => setInputValue(newInputValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default UserAutocomplete;
